import React from 'react'
import { Button, colors, H2, Image, LayoutBand, Paragraph, Row, Separator, Subheading } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { trackLink } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import genericErrorImage from '../../images/generic-error.png'

export const GenericErrorView: React.FC = () => {
  const [t] = useTranslation()

  return (
    <LayoutBand marginY="sm" maxWidth="sm" color={colors.gray02}>
      <Row alignX="center">
        <Image src={genericErrorImage} alt="" maxWidth={650} />
      </Row>
      <Separator />
      <H2 size="H4" centered>
        {t('shared.generic-error-view.heading', 'Oops! Something went wrong.')}
        <Subheading>
          {t(
            'shared.generic-error-view.subheading',
            'Try refreshing the page, or use one of the options below to keep going.'
          )}
        </Subheading>
      </H2>
      <Separator marginY="sm" />
      <Row alignX="center">
        <Button
          emphasis="high"
          onClick={() => {
            trackLink({ name: 'Reload Page' })
            globalThis.location.reload()
          }}
        >
          {t('shared.generic-error-view.reload-button', 'Reload Page')}
        </Button>
      </Row>
      <Separator marginY="lg" />
      <Paragraph centered size="sm">
        <strong>{t('shared.generic-error-view.additional-option', 'Here is another option.')}</strong>
      </Paragraph>
      <Paragraph centered size="sm">
        <Link to="https://www.familysearch.org" external linkName="FamilySearch Home">
          {t('shared.generic-error-view.familysearch-link', 'FamilySearch home page')}
        </Link>
      </Paragraph>
    </LayoutBand>
  )
}
